import React from "react";
import {
  Avatar,
  Box,
  createStyles,
  Grid,
  Theme,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getLocalizedValue } from "../../core/lang";
import CustomIcon from "../../core/custom-icon";
import { useIntl } from "react-intl";
import { LocalizedString } from "../../generated/platform";
import { Locale } from "../../core/api/model";

interface Props {
  expert: {
    fullName: string;
    title: string;
    position: string;
  };
  corporation: {
    corpName: LocalizedString;
  };
  locale: Locale;
  date: {
    startDate: Date;
    endDate: Date;
  };
  title: string;
  text: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      marginRight: theme.spacing(3),
      backgroundColor: theme.palette.secondary.main,
      height: 61,
      width: 61,
      marginTop: theme.spacing(-6),

      [theme.breakpoints.up("md")]: {
        height: 151,
        width: 151,
        marginTop: 0,
        marginRight: theme.spacing(-7),
      },
    },
    avatarIcon: {
      height: 40,
      width: 40,

      [theme.breakpoints.up("md")]: {
        height: 80,
        width: 80,
      },
    },
  })
);

export const MeetingHeader = ({
  expert,
  corporation,
  locale,
  date,
  title,
  text,
}: Props) => {
  const { formatMessage, formatDate } = useIntl();
  const classes = useStyles();

  return (
    <Box pb={{ xs: 5, md: 7.5 }}>
      <Grid container spacing={5}>
        <Grid item xs={12} md={6}>
          <Box pt={{ xs: 5, md: 5 }}>
            <Typography component="h1" variant="h1" color="primary">
              {title}
            </Typography>
            <Box mt={{ xs: 2.5, md: 2 }}>
              <Typography component="h2" variant="body1" color="primary">
                {text}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box pl={{ xs: 0, md: 7 }} pr={{ xs: 0, md: 7 }}>
            <Box
              className="expert-panel"
              mt={{ xs: 2, md: 0 }}
              mr={{ xs: -2, md: 0 }}
              bgcolor="common.white"
              pl={{ xs: 2, md: 5 }}
              pt={{ xs: 2.5, md: 5 }}
              pb={{ xs: 3, md: 3 }}
            >
              <Box display="flex" pb={{ xs: 3, md: 3 }}>
                <Box flexGrow="1" pr={{ xs: 2, md: 5 }} color="primary.main">
                  {expert.fullName ? (
                  <Typography component="h2" variant="subtitle1" gutterBottom>
                    {expert.fullName}
                  </Typography>
                  ) : null}
                  {expert.title || expert.title !== 'null' || expert.title !== null ? (
                  <Box component="p" fontSize="body1.fontSize" mb={0.9}>
                    {formatMessage({
                      id: "MeetingLobbyExpertTitle",
                      defaultMessage: "Titel: ",
                    })}
                    {expert.title}
                  </Box>
                  ) : null}
                  {corporation.corpName ? (
                  <Box component="p" fontSize="body1.fontSize" my={0.9}>
                    {formatMessage({
                      id: "MeetingLobbyExpertCompany",
                      defaultMessage: "Unternehmen: ",
                    })}
                    {getLocalizedValue(locale, corporation.corpName)}
                  </Box>
                  ) : null}
                  {/*TODO @sergej: Fix Data from Platform */}
                  {/*{expert.position ? (*/}
                  {/*<Box component="p" fontSize="body1.fontSize" my={0.9}>*/}
                  {/*  {formatMessage({*/}
                  {/*    id: "MeetingLobbyExpertPosition",*/}
                  {/*    defaultMessage: "Position: ",*/}
                  {/*  })}*/}
                  {/*  {expert.position}*/}
                  {/*</Box>*/}
                  {/*) : null}*/}
                </Box>
                {/*<Box flexShrink="0">*/}
                {/*  <Avatar*/}
                {/*    className={classes.avatar}*/}
                {/*    alt={expert.fullName}*/}
                {/*    src={""}*/}
                {/*  >*/}
                {/*    <CustomIcon*/}
                {/*      iconname="emptyProfile"*/}
                {/*      viewBox="0 0 40 40"*/}
                {/*      className={classes.avatarIcon}*/}
                {/*    />*/}
                {/*  </Avatar>*/}
                {/*</Box>*/}
              </Box>

              <Box
                display="flex"
                justifyContent="space-between"
                color="primary.main"
                pr={{ xs: 3, md: 5 }}
              >
                {date.startDate ? (
                <Box mr={3}>
                  <Typography variant="h3" component='h3' gutterBottom>
                    {formatMessage({
                      id: "Date",
                      defaultMessage: "Datum",
                    })}
                  </Typography>
                  <Typography variant="subtitle2" component='h3'>
                    {formatDate(date.startDate)}
                  </Typography>
                </Box>
                ) : null}
                {date.startDate || date.endDate ? (
                <Box>
                  <Typography variant="h3" component='h3' gutterBottom>
                    {formatMessage({
                      id: "Time",
                      defaultMessage: "Uhrzeit",
                    })}
                  </Typography>
                  <Typography variant="subtitle2" component='h3'>
                    {formatMessage(
                      {
                        id: "MeetingLobbyMeetingTime",
                        defaultMessage: `{startTime} bis {endTime}`,
                      },
                      {
                        startTime: formatDate(date.startDate, {
                          hour: "numeric",
                          minute: "numeric",
                        }),
                        endTime: formatDate(date.endDate, {
                          hour: "numeric",
                          minute: "numeric",
                        }),
                      }
                    )}
                  </Typography>
                </Box>
                ) : null}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
